import React from 'react';
import { PinpadSize } from '../../shared/types.js';

interface NumpadProps {
  onKeyPress: (key: string) => void;
  onClear: () => void;
  onDelete: () => void;
  size?: PinpadSize;
}

const NumpadButton: React.FC<{ onClick: () => void; children: React.ReactNode; className?: string; size: PinpadSize }> = ({ onClick, children, className = '', size }) => {
    const sizeClasses = {
        [PinpadSize.SMALL]: 'h-24 w-24 text-3xl',
        [PinpadSize.MEDIUM]: 'h-32 w-32 text-4xl',
        [PinpadSize.LARGE]: 'h-48 w-48 text-8xl',	
    };
    return (
      <button
        onClick={onClick}
        className={`bg-gray-200 dark:bg-gray-800 hover:bg-gray-300 dark:hover:bg-gray-700 active:bg-gray-400 dark:active:bg-gray-600 text-gray-900 dark:text-white font-bold rounded-lg shadow-lg transition-all duration-150 flex items-center justify-center ${sizeClasses[size]} ${className}`}
      >
        {children}
      </button>
    );
};

const Numpad: React.FC<NumpadProps> = ({ onKeyPress, onClear, onDelete, size = PinpadSize.MEDIUM }) => {
  const keys = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];

  const gapClasses = {
      [PinpadSize.SMALL]: 'gap-2',
      [PinpadSize.MEDIUM]: 'gap-4',
      [PinpadSize.LARGE]: 'gap-6',
  };

  return (
    <div className={`grid grid-cols-3 p-4 bg-gray-300/50 dark:bg-gray-900/50 rounded-xl mx-auto ${gapClasses[size]}`}>
      {keys.map((key) => (
        <NumpadButton key={key} onClick={() => onKeyPress(key)} size={size}>
          {key}
        </NumpadButton>
      ))}
      <NumpadButton onClick={onClear} className="text-red-500 dark:text-red-400" size={size}>C</NumpadButton>
      <NumpadButton onClick={() => onKeyPress('0')} size={size}>0</NumpadButton>
      <NumpadButton onClick={onDelete} className="text-yellow-500 dark:text-yellow-400" size={size}>{'<'}</NumpadButton>
    </div>
  );
};

export default Numpad;